<template lang="pug">
.block-tab
  el-tabs(
    v-model="activeName"
    @tab-click="handleClick"
    type="card"
  )
    el-tab-pane(
      v-for="(item,i) of tabs"
      :key="i"
      :name="item"
      :label="$t(item)"
      :disabled="tabsArr.length !== 0 && tabsArr[i].disabled"
    )
      .block-tab__item(slot="label")
        span {{ $t(item) }}
        img(
          v-if="item === '流程' && isBypass"
          style="position:absolute;right:0;width: 36px;height:33px"
          src="@/umcc/assets/icon-bypass.png"
        )
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default () {
        return []
      },
      required: true
    },
    index: {
      type: Number,
      default () {
        return 0
      }
    },
    tabsArr: {
      type: Array,
      default () {
        return []
      }
    }
  },
  updated () {
    this.activeName = this.tabs[this.index]
  },
  data () {
    return {
      activeName: this.tabs[this.index]
    }
  },
  computed: {
    isBypass () {
      return this.$store.state.campaign.campaignSurvey.is_bypass === 1
    }
  },
  methods: {
    handleClick (tab) {
      this.$emit('change', Number(tab.index))
    }
  }
}
</script>

<style lang="stylus">
.block-tab
  .el-tabs__header
    margin 0
  .el-tabs--card>.el-tabs__header
    border none
    .el-tabs__nav
      border none

  .el-tabs--card>.el-tabs__header .el-tabs__item:first-child
    border-left 1px solid #e4e7ed
  .el-tabs__item
    border-radius 6px 6px 6px 6px
    background #e8e8e8
    min-width 128px
    text-align center
    margin-right 6px
    color #5e5e5e
    position relative
  .el-tabs__item.is-active
    height 46px
    border-radius 6px 6px 0px 0px
    background #fff
    color $main
</style>
